// extracted by mini-css-extract-plugin
export default {"modal":"modal__z62KC","customer":"customer__a0s69","customerContact":"customerContact__ZSmZW"};